import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { ButtonColor, ButtonShape, ButtonSize, ButtonVariant, PaginationItemType, RenderType, } from '../../enums';
import { ChevronIcon, Button } from '../../components';
import { getPaginationItems } from './getPaginationItems';
import styles from './Pagination.module.scss';
const Pagination = ({ totalPages, currentPage, getPageUrl, onPaginationClick, }) => {
    if (totalPages < 1 || currentPage < 1) {
        return null;
    }
    const paginationItems = getPaginationItems(totalPages, Math.min(currentPage, totalPages), getPageUrl);
    return (_jsx("div", { className: "d-flex align-items-center", children: paginationItems.map((paginationItem, index) => {
            const { type, link, page, a11yText = '' } = paginationItem;
            if (type === PaginationItemType.Dots) {
                return (_jsx("div", { className: "mr-1x", children: "..." }, PaginationItemType.Dots));
            }
            const isCurrentPage = type === PaginationItemType.Page && !link;
            const variant = type === PaginationItemType.Page
                ? ButtonVariant.Outlined
                : ButtonVariant.Contained;
            const color = isCurrentPage || type !== PaginationItemType.Page
                ? ButtonColor.BrandDark
                : ButtonColor.Grey;
            const dataTestId = {
                ...(type === PaginationItemType.ArrowLeft
                    ? { 'data-testid': 'previous-pagination-button' }
                    : {}),
                ...(type === PaginationItemType.ArrowRight
                    ? { 'data-testid': 'next-pagination-button' }
                    : {}),
            };
            return (_jsxs(Button
            // eslint-disable-next-line react/no-array-index-key
            , { as: RenderType.Link, className: classNames(styles.paginationButton, {
                    [styles.isCurrentPage]: isCurrentPage,
                }), a11yText: a11yText, disabled: !link && !isCurrentPage, shape: ButtonShape.Icon, variant: variant, size: ButtonSize.Responsive, color: color, href: link, onClick: (event) => {
                    if (onPaginationClick) {
                        onPaginationClick(event, type, link);
                    }
                }, ...dataTestId, children: [type === PaginationItemType.Page && page, type === PaginationItemType.ArrowLeft && (_jsx(ChevronIcon, { className: styles.chevronLeft })), type === PaginationItemType.ArrowRight && (_jsx(ChevronIcon, { className: styles.chevronRight }))] }, `page-${index}`));
        }) }));
};
export { Pagination };
